import boardsInfo from "../../../api/boards.json";
import { ListOfEvents } from "../../ListOfEvents/ListOfEvents";

export const Boards = () => {
	const boardsData = boardsInfo.map((board) => ({
		id: board.boardId,
		info: board.boardInfo,
	}));
	return (
		<section className="container boards">
			<ListOfEvents events={boardsData} />
		</section>
	);
};
